import {Component, Input, OnDestroy, Optional} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Observable, of, Subject} from 'rxjs';
import {startWith, takeUntil} from 'rxjs/operators';
import {
    FieldUiDataAssignmentObj,
    FieldUiDataDateObj,
    FieldUiDataFileUploadObj,
    FieldUiDataNumberObj,
    FieldUiDataObj,
    FieldUiDataSetObj
} from '../../../../../../../generated/generated-core.model';
import {MxFieldConfig, MxFieldCustomizerService} from '../../services/mx-field-customizer.service';

@Component({
    selector: 'mx-dynamic-fields',
    standalone: false,
    templateUrl: './mx-dynamic-fields.component.html',
    styleUrls: ['mx-dynamic-fields.component.scss']
})
export class MxDynamicFieldsComponent implements OnDestroy {

    @Input() fields: Array<FieldUiDataObj | FieldUiDataAssignmentObj
        | FieldUiDataDateObj | FieldUiDataFileUploadObj | FieldUiDataSetObj | FieldUiDataNumberObj>;
    @Input() form: FormGroup;
    @Input() readonlyMode: boolean;
    @Input() fieldConfigs: Map<string, MxFieldConfig> = new Map<string, MxFieldConfig>();
    @Input() layoutClass: string;
    @Input() errorMessage: boolean = true;

    private _destroy$$: Subject<void> = new Subject<void>();

    constructor(@Optional() public customizer: MxFieldCustomizerService) {
        if (!this.customizer) {
            this.customizer = new MxFieldCustomizerService();
        }
    }

    showChild(field: FieldUiDataObj): Observable<string> {
        if (field.showChildDependOn) {
            let dependOnControl = this.form.get([field.showChildDependOn]);
            return dependOnControl.valueChanges
                .pipe(
                    takeUntil(this._destroy$$),
                    startWith(dependOnControl.value)
                );
        } else {
            return of(void 0);
        }
    }

    ngOnDestroy(): void {
        this._destroy$$.next(null);
    }
}
